/**
 *
 * 判断是否是微信进入 如果是微信进入 则进行认证 获取unionId 与连接中的unionId 进行对比
 * 如果是企业微信进入 只可查看提交结果
 */
import { URL_ROOT, QR_APP_ID, QR_OPEN_APP_ID, QR_AGENT_ID } from '@/env';
import React, { useEffect, useState } from 'react';
import {
    Checkbox,
    Radio,
    Button,
    Spin,
    Form,
    Avatar,
    Divider,
    Tag,
    message,
    Result,
    Image,
} from 'antd';
import { SendOutlined, ArrowDownOutlined } from '@/icons';
import styles from './index.module.less';
import {
    getAgreementInfo, getUserInfoByWecomCode,
    openCutsomerInfo,
    openWxToken,
    saveAgreementInfo,
    updateAgreementInfo,
} from '@/api/open';
import useTitle from '@/hook/useTitle';
import wxUtils from '@/page/mobile/wxUtils';
import QRCode from 'qrcode.react';
import dayjs from 'dayjs';
import QrCodeView from '@/page/mobile/QrCodeView';

const url = encodeURI(URL_ROOT + '/wx/mobile/qr');
const appId = QR_APP_ID;
const id = QR_OPEN_APP_ID;
const agentId = QR_AGENT_ID;
export default function WxQrCode() {
    useTitle('签到二维码');
    useEffect(() => {
        wxUtils.optionMenu(false);
        initData();
    }, []);

    const [userId, setUserId] = useState(false);
    const [userName, setUserName] = useState(false);
    const [loading, setLoading] = useState(true);

    function initData() {
        setLoading(true);
        const currentUrl = window.location.href;
        if (navigator.userAgent.indexOf('wxwork') != -1) {
            // 企业微信
            if (currentUrl.includes('code')) {
                const value = window.location.href.split('=')[1];
                const code = value.split('&')[0];
                getUserInfo(code);
            } else {
                auth();
            }
        }
        setLoading(false);
    }

    function auth() {
        window.location = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${url}&response_type=code&scope=snsapi_base&state=STATE&agentid=${agentId}#wechat_redirect`;
    }

    function getUserInfo(code) {
        getUserInfoByWecomCode(id, code).then(res => {
            setUserId(res.data.extId);
            setUserName(res.data.name);
        });
    }

    function renderForm() {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh', // 设定高度为浏览器窗口的高度，使其内容垂直居中
            }}>
                {userId && <QrCodeView
                    title={userName}
                    subTitle={userId}
                    data={userId + '|' + dayjs().format('YYYY-MM-DD HH-mm')}
                />
                }
            </div>
            // <QrCodeView
            //     title="这是人名"
            //     subTitle="这是 id这是 id这是 id"
            //     data="hello world this is a qrcode demo"
            // />
            // </div>
        )
    }


    return <div>{!loading && renderForm()}</div>;
}
